import React, { ReactNode } from 'react';
import { ErrorLabel } from '@eika/label';

interface InputErrorProps {
    error: string | ReactNode;
}

const InputError = ({ error }: InputErrorProps): JSX.Element =>
    typeof error === 'string' ? <ErrorLabel className="sgw-checkbox__error-label" text={error} /> : <>{error}</>;

export default InputError;
